export default {
  name: "email-verification-invalid",
  components: {},
  props: [],
  data() {
    return { baseURL: process.env.VUE_APP_PUBLIC_BASE_URL };
  },
  computed: {},
  mounted() {},
  methods: {}
};
